// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"X1-z","dimensionLabel":"Y1-z","styleChooserControlWrapper":"Z1-z","styleChooserControl":"_1-z","disabled":"a2-z","giftCard":"b2-z","styleChooserText":"c2-z"};